<ng-container *ngIf="savedCart$ | async as cart">
  <ng-container *ngIf="showCartDetails(cart); else emptyCartItems">
    <div
      *cxFeature="'!a11yRemoveStatusLoadedRole'"
      role="status"
      [attr.aria-label]="'common.loaded' | cxTranslate"
    ></div>
    <div class="cart-details-wrapper">
      <cx-cart-details
        [customCart]="cart"
      />
    </div>
  </ng-container>
</ng-container>
<ng-template #emptyCartItems>
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>

<ng-template let-ctx #addToCartBtn>
  <cx-add-to-cart
    [productCode]="ctx.item.product?.code"
    [product]="ctx.item.product"
    [showQuantity]="false"
    [options]="ctx.options"
    [pickupStore]="ctx.item.deliveryPointOfService?.name"
  >
  </cx-add-to-cart>
</ng-template>
